"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[362],{

/***/ 10362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GY": function() { return /* reexport */ portfolio_InternationalSEO; },
  "wx": function() { return /* reexport */ portfolio_LocalSEO; },
  "sc": function() { return /* reexport */ portfolio_Portfolio2; }
});

// UNUSED EXPORTS: Portfolio10, Portfolio11, Portfolio12, Portfolio3, Portfolio4, Portfolio5, Portfolio6, Portfolio7, Portfolio8, Portfolio9

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/reuseable/Carousel.tsx
var reuseable_Carousel = __webpack_require__(77632);
// EXTERNAL MODULE: ./src/data/keywords.ts
var keywords = __webpack_require__(74870);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/blocks/portfolio/LocalSEO.tsx



// import * as All from 'data/keywords';

var LocalSEO = function(param) {
    var initialslide = param.initialslide;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container-fluid",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(reuseable_Carousel/* default */.Z, {
            grabCursor: true,
            className: "blog grid-view mb-1 mb-md-1",
            initialSlide: initialslide,
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                768: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3
                }
            },
            children: keywords.LocalSEOArrays.map(function(param) {
                var item = param.item, title = param.title;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        cursor: "pointer"
                    },
                    className: "card overflow-hidden shadow-none position-relative",
                    title: title,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        //legacyBehavior2 passHref2
                        href: "/" + keywords.LocalSEOArrays[item].keywords[0].url + "/" + keywords.LocalSEOArrays[item].keywords[0].title.toLowerCase().replace(/ /g, "-"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "dropdown-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                    className: "w-100 overflow-hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: keywords.LocalSEOArrays[item].keywords[1].title,
                                        src: "/img/clients/" + keywords.LocalSEOArrays[item].keywords[1].title.toLowerCase().replace(/ /g, "-") + ".jpg",
                                        // srcSet={`${image}@2x.jpg 2x`}
                                        className: "rounded lift d-block w-25"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "card-body position-absolute top-0 ".concat(keywords.LocalSEOArrays[item].displayText, " "),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                                        className: "border-0 mb-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "blockquote-details",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "info",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        className: "mb-0 ".concat(keywords.LocalSEOArrays[item].displayTextColor, " font-weight-bold"),
                                                        children: title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mb-0 ".concat(keywords.LocalSEOArrays[item].displayTextColor, " desktop"),
                                                        children: keywords.LocalSEOArrays[item].category
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }, item);
            })
        })
    });
};
/* harmony default export */ var portfolio_LocalSEO = (LocalSEO);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/data/client.ts
// used in the client-1, hero-21 block
// '/img/clients/technical-seo-agency/credit-suisse-full.png',
var clientList = [
    // '/img/clients/technical-seo-agency/logos/bbc.png',  
    "/img/clients/technical-seo-agency/logos/bbc.png",
    "/img/clients/technical-seo-agency/logos/itv.png",
    "/img/clients/technical-seo-agency/logos/addidas.png",
    "/img/clients/technical-seo-agency/logos/channel-4.png",
    "/img/clients/technical-seo-agency/logos/christian-aid.svg",
    "/img/clients/technical-seo-agency/logos/credit-suisse.png",
    "/img/clients/technical-seo-agency/logos/frontline.webp",
    "/img/clients/technical-seo-agency/logos/ft.svg",
    "/img/clients/technical-seo-agency/logos/sky.png",
    "/img/clients/technical-seo-agency/logos/technical-seo-agency.svg",
    "/img/clients/technical-seo-agency/logos/thames-water.svg",
    "/img/clients/technical-seo-agency/logos/hogarth.jpg", 
];
// used in the client-4, client-5 block
var client_clientList2 = (/* unused pure expression or super */ null && ([
    "/img/brands/z1.png",
    "/img/brands/z2.png",
    "/img/brands/z3.png",
    "/img/brands/z4.png",
    "/img/brands/z5.png",
    "/img/brands/z6.png",
    "/img/brands/z7.png",
    "/img/brands/z8.png"
]));


;// CONCATENATED MODULE: ./src/components/blocks/clients/Clients1.tsx

// -------- data -------- //

var Clients1_Clients1 = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "row gx-0 gx-md-8 gx-xl-12 gy-8 align-items-center client-logos",
        children: clientList.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-4 col-md-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                    className: "px-5 px-md-0 px-lg-2 px-xl-3 px-xxl-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        style: {
                            filter: "grayscale(100%)",
                            maxHeight: "80px",
                            width: "auto",
                            margin: "0 auto",
                            display: "block"
                        },
                        src: item,
                        alt: item.split("/img/clients/technical-seo-agency/logos/")[1]
                    })
                })
            }, item);
        })
    });
};
/* harmony default export */ var clients_Clients1 = (Clients1_Clients1);

// EXTERNAL MODULE: ./src/data/demo-8.ts + 1 modules
var demo_8 = __webpack_require__(31657);
;// CONCATENATED MODULE: ./src/components/blocks/clients/Clients2.tsx


var Clients2 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-lg-8 gx-xl-12 gy-10 gy-lg-0 mb-13 mb-md-17",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "col-lg-4",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "display-4 mb-3 pe-xxl-5",
                        children: "Trusted by over 25000+ clients"
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: "lead fs-lg mb-0 pe-xxl-5",
                        children: [
                            "We ",
                            /*#__PURE__*/ _jsx("span", {
                                className: "underline",
                                children: "bring solutions"
                            }),
                            " to make life easier for our customers."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-lg-8",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "row row-cols-2 row-cols-md-4 gx-0 gx-md-8 gx-xl-12 gy-11 mt-n10",
                    children: clients.map(function(param) {
                        var id = param.id, image = param.image;
                        return /*#__PURE__*/ _jsx("div", {
                            className: "col",
                            children: /*#__PURE__*/ _jsx("figure", {
                                className: "px-4 px-lg-3 px-xxl-5",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: image,
                                    alt: "brand"
                                })
                            })
                        }, id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var clients_Clients2 = ((/* unused pure expression or super */ null && (Clients2)));

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/blocks/clients/Clients3.tsx



var Clients3 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "fs-15 text-uppercase text-muted text-center mb-8",
                children: "Trusted by Over 5000 Clients"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "px-lg-5 mb-14 mb-md-19",
                children: /*#__PURE__*/ _jsx(Clients1, {})
            })
        ]
    });
};
/* harmony default export */ var clients_Clients3 = ((/* unused pure expression or super */ null && (Clients3)));

// EXTERNAL MODULE: ./src/components/reuseable/FigureImage.tsx
var reuseable_FigureImage = __webpack_require__(42744);
;// CONCATENATED MODULE: ./src/components/blocks/clients/Clients4.tsx


// -------- data -------- //

var Clients4 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-gray",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container py-14 py-md-16",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gx-lg-8 gx-xl-12 gy-10 gy-lg-0 mb-10",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-4 mt-lg-2",
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-4 mb-3 pe-xxl-5",
                                children: "Trusted by over 300+ clients"
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                className: "lead fs-lg mb-0 pe-xxl-5",
                                children: [
                                    "We ",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "underline",
                                        children: "bring solutions"
                                    }),
                                    " to make life easier for our customers."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-8",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "row row-cols-2 row-cols-md-4 gx-0 gx-md-8 gx-xl-12 gy-12",
                            children: clientList2.map(function(item) {
                                return /*#__PURE__*/ _jsx("div", {
                                    className: "col",
                                    children: /*#__PURE__*/ _jsx(FigureImage, {
                                        width: 450,
                                        height: 301,
                                        src: item,
                                        className: "px-3 px-md-0 px-xxl-2"
                                    })
                                }, item);
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var clients_Clients4 = ((/* unused pure expression or super */ null && (Clients4)));

;// CONCATENATED MODULE: ./src/components/blocks/clients/Clients5.tsx


// -------- data -------- //

var Clients5 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container py-15 py-md-17",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gx-lg-8 gx-xl-12 gy-10 gy-lg-0",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-4 mt-lg-2",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-16 text-uppercase text-muted mb-3",
                                children: "Our Clients"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-3 mb-3 pe-xxl-5",
                                children: "Trusted by over 300+ clients"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "lead fs-lg mb-0 pe-xxl-7",
                                children: "We bring solutions to make life easier for our customers."
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-8",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "row row-cols-2 row-cols-md-4 gx-0 gx-md-8 gx-xl-12 gy-12",
                            children: clientList2.map(function(item) {
                                return /*#__PURE__*/ _jsx("div", {
                                    className: "col",
                                    children: /*#__PURE__*/ _jsx(FigureImage, {
                                        width: 450,
                                        height: 301,
                                        src: item,
                                        className: "px-3 px-md-0 px-xxl-2"
                                    })
                                }, item);
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var clients_Clients5 = ((/* unused pure expression or super */ null && (Clients5)));

;// CONCATENATED MODULE: ./src/components/blocks/clients/index.ts







;// CONCATENATED MODULE: ./src/components/blocks/portfolio/Portfolio2.tsx



var Portfolio2 = function(param) {
    var title = param.title;
    var router = (0,next_router.useRouter)();
    var _query = router.query, referrer = _query.referrer, location = _query.location;
    var query = router.query;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "overflow-hidden position-relative",
        style: {
            zIndex: 1,
            position: "relative"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container pb-9 pb-md-14",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-lg-9 col-xl-8 col-xxl-7 mx-auto text-center mb-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "fs-15 text-uppercase text-muted mb-3",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "display-4 mb-8",
                                children: "Previous Clients"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mx-auto text-center",
                                children: [
                                    "James has lead teams and developed user interfaces for tech companies and agencies. SEOptimist ",
                                    " ",
                                    "SEO offers the same high level of quality in design and search\xa0 engine optimisation to local businesses."
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-lg-10 mx-auto text-center mb-15",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-lg-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(clients_Clients1, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "swiper-container grid-view nav-bottom nav-color mb-14"
                })
            ]
        })
    });
};
/* harmony default export */ var portfolio_Portfolio2 = (Portfolio2);

// EXTERNAL MODULE: ./src/components/reuseable/links/NextLink.tsx
var links_NextLink = __webpack_require__(99472);
;// CONCATENATED MODULE: ./src/data/portfolio.ts
// used in the portfolio-1 block
var localSEO = [
    {
        id: 1013,
        mainKeyword: "local SEO packages",
        subKeyword: "local SEO services UK",
        category: "seo, ppc, social, web design",
        title: "The Brighton Removals Company",
        alt: "The Brighton Removals Company",
        displayText: "d-none",
        displayTextColor: "text-white"
    },
    {
        id: 1022,
        mainKeyword: "professional UK SEO",
        subKeyword: "national SEO services",
        category: "seo, bespoke website design",
        title: "Gold Bear Removals",
        alt: "Gold Bear Removals",
        displayText: "d-none",
        displayTextColor: "text-dark"
    },
    {
        id: 1018,
        mainKeyword: "web design for tradesmen",
        subKeyword: "websites for tradesmen",
        category: "seo, web design",
        title: "The Tree Company Sussex",
        alt: "The Tree Company Sussex",
        displayText: "d-none",
        displayTextColor: "text-white"
    },
    {
        id: 1019,
        mainKeyword: "SEO company",
        subKeyword: "SEO companies near me",
        category: "seo, ppc, ecommerce design",
        title: "Box Boys Packaging",
        alt: "Box Boys Packaging",
        displayText: "d-inline-block",
        displayTextColor: "text-dark"
    },
    {
        id: 1020,
        mainKeyword: "search engine consultants",
        subKeyword: "search engine marketing London",
        category: "seo, web design",
        title: "Brighton Boxes",
        alt: "Brighton Boxes",
        displayText: "d-inline-block",
        displayTextColor: "text-light"
    },
    {
        id: 1022,
        mainKeyword: "professional UK SEO",
        subKeyword: "national SEO services",
        category: "seo, bespoke website design",
        title: "Gold Bear Removals",
        alt: "Gold Bear Removals",
        displayText: "d-none",
        displayTextColor: "text-dark"
    },
    {
        id: 1018,
        mainKeyword: "web design for tradesmen",
        subKeyword: "websites for tradesmen",
        category: "seo, web design",
        title: "The Tree Company Sussex",
        alt: "The Tree Company Sussex",
        displayText: "d-none",
        displayTextColor: "text-white"
    },
    {
        id: 1019,
        mainKeyword: "SEO company",
        subKeyword: "SEO companies near me",
        category: "seo, ppc, ecommerce design",
        title: "Box Boys Packaging",
        alt: "Box Boys Packaging",
        displayText: "d-inline-block",
        displayTextColor: "text-dark"
    },
    {
        id: 1020,
        mainKeyword: "search engine consultants",
        subKeyword: "search engine marketing London",
        category: "seo, web design",
        title: "Brighton Boxes",
        alt: "Brighton Boxes",
        displayText: "d-inline-block",
        displayTextColor: "text-light"
    },
    {
        id: 1014,
        mainKeyword: "affordable SEO London",
        subKeyword: "affordable SEO services London",
        category: "seo, ppc",
        title: "Smooth Mover Brighton",
        alt: "Smooth Mover Brighton",
        displayText: "d-inline-block",
        displayTextColor: "text-dark"
    },
    {
        id: 1015,
        mainKeyword: "digital marketing for health and wellness",
        subKeyword: "digital health marketing agency",
        category: "digital marketing, health",
        title: "Charlotte Watts",
        alt: "Charlotte Watts Yoga, Health & Nutrition",
        displayText: "d-inline-block",
        displayTextColor: "text-dark"
    },
    {
        id: 1016,
        mainKeyword: "WordPress SEO agency",
        subKeyword: "WordPress SEO consultant",
        category: "seo, ppc, social, web design",
        title: "London Hair by Jackie",
        alt: "London Hair by Jackie",
        displayText: "d-inline-block",
        displayTextColor: "text-white"
    },
    {
        id: 1017,
        mainKeyword: "small business marketing consultant",
        subKeyword: "web design services for small business",
        category: "seo, ppc, social, woocommerce",
        title: "The BodySurf School",
        alt: "The BodySurf School",
        displayText: "d-inline-block",
        displayTextColor: "text-white"
    },
    {
        id: 1021,
        mainKeyword: "web design West Sussex",
        subKeyword: "web design Sussex",
        category: "wordpress, web services",
        title: "Miguel Madeira Music",
        alt: "Miguel Madeira Music",
        displayText: "d-none",
        displayTextColor: "text-white"
    }, 
];
// used in the internationalSEO block
var internationalSEO = [
    {
        id: 0,
        mainKeyword: "hotel SEO company",
        subKeyword: "multilingual SEO services",
        category: "multilingual seo",
        title: "JJW Hotels",
        alt: "JJW Hotels",
        displayText: "d-inline-block",
        displayTextColor: "text-white"
    },
    {
        id: 1,
        mainKeyword: "international SEO agency London",
        subKeyword: "international SEO agency",
        category: "on-page seo, linking strategy",
        title: "MBI International",
        alt: "MBI International",
        displayText: "d-inline-block",
        displayTextColor: "text-white"
    }
];
// used in the portfolio-1 block
var portfolio_portfolioList2 = [
    {
        id: 0,
        url: "#",
        category: "Mobile Design",
        title: "Cras Fermentum Sem",
        image: {
            "1x": "/img/photos/sp1.jpg",
            "2x": "/img/photos/sp1@2x.jpg 2x"
        }
    },
    {
        id: 1,
        url: "#",
        category: "Web Design",
        title: "Venenatis Euismod Vehicula",
        image: {
            "1x": "/img/photos/sp2.jpg",
            "2x": "/img/photos/sp2@2x.jpg 2x"
        }
    },
    {
        id: 2,
        url: "#",
        category: "Stationary",
        title: "Tortor Tellus Cursus",
        image: {
            "1x": "/img/photos/sp3.jpg",
            "2x": "/img/photos/sp3@2x.jpg 2x"
        }
    },
    {
        id: 3,
        url: "#",
        category: "Web Application",
        title: "Ridiculus Sem Parturient",
        image: {
            "1x": "/img/photos/sp4.jpg",
            "2x": "/img/photos/sp4@2x.jpg 2x"
        }
    },
    {
        id: 4,
        url: "#",
        category: "Web Design",
        title: "Cursus Sollicitudin Adipiscing",
        image: {
            "1x": "/img/photos/sp5.jpg",
            "2x": "/img/photos/sp5@2x.jpg 2x"
        }
    },
    {
        id: 5,
        url: "#",
        category: "Stationary",
        title: "Fringilla Quam Vulputate",
        image: {
            "1x": "/img/photos/sp6.jpg",
            "2x": "/img/photos/sp6@2x.jpg 2x"
        }
    }
];
// used in the portfolio-4 block
var portfolio_portfolioList3 = [
    {
        id: 1,
        photos: 5,
        category: "Wedding",
        name: "Lucy & David",
        image: {
            "1x": "/img/photos/fc1.jpg",
            "2x": "/img/photos/fc1@2x.jpg 2x"
        }
    },
    {
        id: 2,
        photos: 8,
        category: "Wedding",
        name: "Stacy & Thomas",
        image: {
            "1x": "/img/photos/fc2.jpg",
            "2x": "/img/photos/fc2@2x.jpg 2x"
        }
    },
    {
        id: 3,
        photos: 7,
        category: "Couples",
        name: "Katherine & Jack",
        image: {
            "1x": "/img/photos/fc3.jpg",
            "2x": "/img/photos/fc3@2x.jpg 2x"
        }
    },
    {
        id: 4,
        photos: 9,
        category: "Wedding",
        name: "Jolene & William",
        image: {
            "1x": "/img/photos/fc4.jpg",
            "2x": "/img/photos/fc4@2x.jpg 2x"
        }
    },
    {
        id: 5,
        photos: 6,
        category: "Engagement",
        name: "Jenn & Richard",
        image: {
            "1x": "/img/photos/fc5.jpg",
            "2x": "/img/photos/fc5@2x.jpg 2x"
        }
    },
    {
        id: 6,
        photos: 8,
        category: "Wedding",
        name: "Gloria & Leo",
        image: {
            "1x": "/img/photos/fc6.jpg",
            "2x": "/img/photos/fc6@2x.jpg 2x"
        }
    }
];
// used in the portfolio-5 block
var portfolio_portfolioList4 = [
    {
        id: 1,
        image: "pf1",
        title: "Fringilla Nullam",
        category: "drinks events"
    },
    {
        id: 2,
        image: "pf2",
        title: "Ridiculus Parturient",
        category: "events"
    },
    {
        id: 3,
        image: "pf3",
        title: "Ornare Ipsum",
        category: "pastries events"
    },
    {
        id: 4,
        image: "pf4",
        title: "Nullam Mollis",
        category: "events"
    },
    {
        id: 5,
        image: "pf5",
        title: "Euismod Risus",
        category: "pastries events"
    },
    {
        id: 6,
        image: "pf6",
        title: "Ridiculus Tristique",
        category: "foods"
    },
    {
        id: 7,
        image: "pf7",
        title: "Sollicitudin Pharetra",
        category: "foods drinks"
    },
    {
        id: 8,
        image: "pf8",
        title: "Tristique Venenatis",
        category: "pastries"
    },
    {
        id: 9,
        image: "pf9",
        title: "Cursus Fusce",
        category: "events"
    },
    {
        id: 10,
        image: "pf10",
        title: "Consectetur Malesuada",
        category: "foods"
    },
    {
        id: 11,
        image: "pf11",
        title: "Ultricies Aenean",
        category: "drinks"
    },
    {
        id: 12,
        image: "pf12",
        title: "Pellentesque Commodo",
        category: "foods"
    },
    {
        id: 13,
        image: "pf13",
        title: "Ultricies Aenean",
        category: "drinks"
    }
];
// used in the portfolio-8 block
var portfolio_portfolioList5 = [
    {
        id: 1,
        color: "yellow",
        category: "Coffee",
        title: "Cras Fermentum Sem",
        image: "/img/photos/pd1.jpg"
    },
    {
        id: 2,
        color: "red",
        category: "Stationary",
        title: "Mollis Ipsum Mattis",
        image: "/img/photos/pd2.jpg"
    },
    {
        id: 3,
        color: "orange",
        category: "Branding",
        title: "Ipsum Ultricies Cursus",
        image: "/img/photos/pd3.jpg"
    },
    {
        id: 4,
        color: "purple",
        category: "Product",
        title: "Inceptos Euismod Egestas",
        image: "/img/photos/pd4.jpg"
    },
    {
        id: 5,
        color: "leaf",
        category: "Print",
        title: "Sollicitudin Ornare Porta",
        image: "/img/photos/pd5.jpg"
    },
    {
        id: 6,
        color: "aqua",
        category: "Workshop",
        title: "Ipsum Mollis Vulputate",
        image: "/img/photos/pd6.jpg"
    }
];
// used in the portfolio-10, portfolio-11 block
var portfolio_portfolioList6 = [
    {
        id: 1,
        category: "Stationary",
        link: "/single-project-1",
        title: "Cras Fermentum Sem",
        image: "/img/photos/pd7.jpg",
        fullImage: "/img/photos/pd7-full.jpg"
    },
    {
        id: 2,
        link: "/single-project-1",
        category: "Magazine, Book",
        title: "Mollis Ipsum Mattis",
        image: "/img/photos/pd8.jpg",
        fullImage: "/img/photos/pd8-full.jpg"
    },
    {
        id: 3,
        category: "Packaging",
        link: "/single-project-1",
        title: "Ipsum Ultricies Cursus",
        image: "/img/photos/pd9.jpg",
        fullImage: "/img/photos/pd9-full.jpg"
    },
    {
        id: 4,
        link: "/single-project-1",
        image: "/img/photos/pd10.jpg",
        category: "Stationary, Branding",
        title: "Inceptos Euismod Egestas",
        fullImage: "/img/photos/pd10-full.jpg"
    },
    {
        id: 5,
        category: "Packaging",
        link: "/single-project-1",
        image: "/img/photos/pd11.jpg",
        title: "Ipsum Mollis Vulputate",
        fullImage: "/img/photos/pd11-full.jpg"
    }
];
var projects = [
    {
        id: 1,
        category: "Stationary",
        link: "/single-project-1",
        title: "Cras Fermentum Sem",
        image: "/img/photos/pd7.jpg",
        fullImage: "/img/photos/pd7-full.jpg"
    },
    {
        id: 2,
        link: "/single-project-1",
        category: "Magazine, Book",
        title: "Mollis Ipsum Mattis",
        image: "/img/photos/pd8.jpg",
        fullImage: "/img/photos/pd8-full.jpg"
    },
    {
        id: 3,
        category: "Packaging",
        link: "/single-project-1",
        title: "Ipsum Ultricies Cursus",
        image: "/img/photos/pd9.jpg",
        fullImage: "/img/photos/pd9-full.jpg"
    },
    {
        id: 4,
        link: "/single-project-1",
        image: "/img/photos/pd10.jpg",
        category: "Stationary, Branding",
        title: "Inceptos Euismod Egestas",
        fullImage: "/img/photos/pd10-full.jpg"
    },
    {
        id: 5,
        category: "Packaging",
        link: "/single-project-1",
        image: "/img/photos/pd11.jpg",
        title: "Ipsum Mollis Vulputate",
        fullImage: "/img/photos/pd11-full.jpg"
    }
];

;// CONCATENATED MODULE: ./src/components/blocks/portfolio/Portfolio3.tsx




// -------- data -------- //

var Portfolio3 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "overflow-hidden",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "container pt-12 pt-lg-7 pb-14 pb-md-16",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "row",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "col-lg-10 col-xl-9 col-xxl-8 mx-auto text-center",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "fs-16 text-uppercase text-primary mb-3",
                                    children: "Latest Projects"
                                }),
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "display-3 mb-10",
                                    children: "Check out some of our awesome projects with creative ideas and great design."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "swiper-container grid-view nav-bottom nav-color mb-14",
                        children: /*#__PURE__*/ _jsx(Carousel, {
                            grabCursor: true,
                            slidesPerView: 2,
                            pagination: false,
                            className: "overflow-visible",
                            breakpoints: {
                                768: {
                                    slidesPerView: 2
                                },
                                0: {
                                    slidesPerView: 1
                                }
                            },
                            children: portfolioList2.map(function(param) {
                                var id = param.id, url = param.url, image = param.image, category = param.category, title = param.title;
                                return /*#__PURE__*/ _jsxs(Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx("figure", {
                                            className: "rounded mb-7",
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: image["1x"],
                                                srcSet: image["2x"],
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "project-details d-flex justify-content-center flex-column",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "post-header",
                                                children: [
                                                    /*#__PURE__*/ _jsx("h2", {
                                                        className: "post-title h3",
                                                        children: /*#__PURE__*/ _jsx(NextLink, {
                                                            title: title,
                                                            className: "link-dark",
                                                            href: url
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "post-category text-ash",
                                                        children: category
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, id);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "divider text-soft-primary mx-n2",
                children: /*#__PURE__*/ _jsx("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 1440 100",
                    children: /*#__PURE__*/ _jsx("path", {
                        fill: "currentColor",
                        d: "M1260,1.65c-60-5.07-119.82,2.47-179.83,10.13s-120,11.48-180,9.57-120-7.66-180-6.42c-60,1.63-120,11.21-180,16a1129.52,1129.52,0,0,1-180,0c-60-4.78-120-14.36-180-19.14S60,7,30,7H0v93H1440V30.89C1380.07,23.2,1319.93,6.15,1260,1.65Z"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var portfolio_Portfolio3 = ((/* unused pure expression or super */ null && (Portfolio3)));

;// CONCATENATED MODULE: ./src/components/blocks/portfolio/Portfolio4.tsx



// -------- data -------- //

var Portfolio4 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light",
        children: /*#__PURE__*/ _jsx("div", {
            className: "overflow-hidden",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "container py-14 py-md-16",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "row",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "col-lg-9 col-xl-8 col-xxl-7 mx-auto text-center",
                            children: [
                                /*#__PURE__*/ _jsx("i", {
                                    className: "icn-flower text-leaf fs-30 opacity-25"
                                }),
                                /*#__PURE__*/ _jsxs("h2", {
                                    className: "display-5 text-center mt-2 mb-10",
                                    children: [
                                        "Some of wonderful love stories ",
                                        /*#__PURE__*/ _jsx("br", {
                                            className: "d-none d-md-block"
                                        }),
                                        " I witnessed and had the chance to capture"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "swiper-container grid-view nav-bottom nav-color mb-14 text-center",
                        children: /*#__PURE__*/ _jsx(Carousel, {
                            className: "overflow-visible pb-2",
                            pagination: false,
                            breakpoints: {
                                0: {
                                    slidesPerView: 1
                                },
                                768: {
                                    slidesPerView: 2
                                }
                            },
                            children: portfolioList3.map(function(item) {
                                return /*#__PURE__*/ _jsxs("div", {
                                    className: "card shadow-lg",
                                    children: [
                                        /*#__PURE__*/ _jsxs("figure", {
                                            className: "card-img-top overlay overlay-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Link, {
                                                    // legacyBehavior2 passHref2 
                                                    href: "#",
                                                    children: /*#__PURE__*/ _jsxs("a", {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("img", {
                                                                className: "img-fluid",
                                                                src: item.image["1x"],
                                                                srcSet: item.image["2x"],
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "bg"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("figcaption", {
                                                    children: /*#__PURE__*/ _jsx("h5", {
                                                        className: "from-top mb-0",
                                                        children: "View Gallery"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "card-body p-6",
                                            children: [
                                                /*#__PURE__*/ _jsx("h3", {
                                                    className: "fs-21 mb-1",
                                                    children: item.name
                                                }),
                                                /*#__PURE__*/ _jsxs("ul", {
                                                    className: "post-meta fs-16 mb-0",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("li", {
                                                            children: [
                                                                item.photos,
                                                                " Photos"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("li", {
                                                            children: item.category
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, item.id);
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var portfolio_Portfolio4 = ((/* unused pure expression or super */ null && (Portfolio4)));

// EXTERNAL MODULE: ./src/hooks/useIsotope.ts
var hooks_useIsotope = __webpack_require__(80959);
;// CONCATENATED MODULE: ./src/components/blocks/portfolio/Portfolio5.tsx



var Portfolio5 = function() {
    var ref = useIsotope(), filterKey = ref.filterKey, handleFilterKeyChange = ref.handleFilterKeyChange;
    // filter list
    var filterList = [
        {
            id: 1,
            title: "All",
            value: "*"
        },
        {
            id: 2,
            title: "Foods",
            value: ".foods"
        },
        {
            id: 3,
            title: "Drinks",
            value: ".drinks"
        },
        {
            id: 4,
            title: "Events",
            value: ".events"
        },
        {
            id: 5,
            title: "Pastries",
            value: ".pastries"
        }
    ];
    return /*#__PURE__*/ _jsx("section", {
        id: "portfolio",
        children: /*#__PURE__*/ _jsx("div", {
            className: "wrapper bg-gray",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "container py-15 py-md-17 text-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "row",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "col-lg-10 col-xl-8 col-xxl-7 mx-auto mb-8",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "display-5 mb-3",
                                    children: "My Selected Shots"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "lead fs-lg",
                                    children: "Photography is my passion and I love to turn ideas into beautiful things."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "grid grid-view projects-masonry",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "isotope-filter filter mb-10",
                                children: /*#__PURE__*/ _jsx("ul", {
                                    children: filterList.map(function(param) {
                                        var id = param.id, title = param.title, value = param.value;
                                        return /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                onClick: handleFilterKeyChange(value),
                                                className: "filter-item ".concat(filterKey === value ? "active" : ""),
                                                children: title
                                            })
                                        }, id);
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "row gx-md-6 gy-6 isotope",
                                children: portfolioList4.map(function(param) {
                                    var category = param.category, id = param.id, image = param.image, title = param.title;
                                    return /*#__PURE__*/ _jsx("div", {
                                        className: "project item col-md-6 col-xl-4 ".concat(category),
                                        children: /*#__PURE__*/ _jsxs("figure", {
                                            className: "overlay overlay-1 rounded",
                                            children: [
                                                /*#__PURE__*/ _jsxs("a", {
                                                    href: "/img/photos/".concat(image, "-full.jpg"),
                                                    "data-glightbox": true,
                                                    "data-gallery": "shots-group",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("img", {
                                                            src: "/img/photos/".concat(image, ".jpg"),
                                                            alt: title
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "bg"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("figcaption", {
                                                    children: /*#__PURE__*/ _jsx("h5", {
                                                        className: "from-top mb-0",
                                                        children: title
                                                    })
                                                })
                                            ]
                                        })
                                    }, id);
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var portfolio_Portfolio5 = ((/* unused pure expression or super */ null && (Portfolio5)));

;// CONCATENATED MODULE: ./src/components/blocks/portfolio/Portfolio6.tsx


var Portfolio6 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "projects-tiles",
        children: /*#__PURE__*/ _jsx("div", {
            className: "project grid grid-view",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gx-md-8 gx-xl-12 gy-10 gy-md-12 isotope",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-6",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "item mt-md-7 mt-lg-15",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "project-details d-flex justify-content-center align-self-end flex-column ps-0 pb-0",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "post-header",
                                        children: [
                                            /*#__PURE__*/ _jsx("h2", {
                                                className: "display-4 mb-4 pe-xxl-15",
                                                children: "Check out some of our recent projects below."
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "lead fs-lg mb-0",
                                                children: "We love to turn ideas into beautiful things."
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "item mt-12",
                                children: [
                                    /*#__PURE__*/ _jsx(Link, {
                                        // legacyBehavior2 passHref2 
                                        href: "#",
                                        children: /*#__PURE__*/ _jsx("a", {
                                            children: /*#__PURE__*/ _jsx("figure", {
                                                className: "lift rounded mb-6",
                                                children: /*#__PURE__*/ _jsx("img", {
                                                    src: "/img/photos/rp2.jpg",
                                                    srcSet: "/img/photos/rp2@2x.jpg 2x",
                                                    alt: "demo"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "post-category text-line mb-3 text-leaf",
                                        children: "Invitation"
                                    }),
                                    /*#__PURE__*/ _jsx("h2", {
                                        className: "post-title h3",
                                        children: "Mollis Ipsum Mattis"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-6",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "item",
                                children: [
                                    /*#__PURE__*/ _jsx(Link, {
                                        // legacyBehavior2 passHref2 
                                        href: "#",
                                        children: /*#__PURE__*/ _jsx("a", {
                                            children: /*#__PURE__*/ _jsx("figure", {
                                                className: "lift rounded mb-6",
                                                children: /*#__PURE__*/ _jsx("img", {
                                                    src: "/img/photos/rp1.jpg",
                                                    srcSet: "/img/photos/rp1@2x.jpg 2x",
                                                    alt: ""
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "post-category text-line mb-3 text-violet",
                                        children: "Stationary"
                                    }),
                                    /*#__PURE__*/ _jsx("h2", {
                                        className: "post-title h3",
                                        children: "Ipsum Ultricies Cursus"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "item mt-12",
                                children: [
                                    /*#__PURE__*/ _jsx(Link, {
                                        // legacyBehavior2 passHref2 
                                        href: "#",
                                        children: /*#__PURE__*/ _jsx("a", {
                                            children: /*#__PURE__*/ _jsx("figure", {
                                                className: "lift rounded mb-6",
                                                children: /*#__PURE__*/ _jsx("img", {
                                                    src: "/img/photos/rp3.jpg",
                                                    srcSet: "/img/photos/rp3@2x.jpg 2x",
                                                    alt: ""
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "post-category text-line mb-3 text-purple",
                                        children: "Notebook"
                                    }),
                                    /*#__PURE__*/ _jsx("h2", {
                                        className: "post-title h3",
                                        children: "Magna Tristique Inceptos"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var portfolio_Portfolio6 = ((/* unused pure expression or super */ null && (Portfolio6)));

;// CONCATENATED MODULE: ./src/components/blocks/portfolio/Portfolio7.tsx


var Portfolio7 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-14 py-md-16",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row align-items-center mb-7",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-8 col-lg-8 col-xl-7 col-xxl-6 pe-lg-17",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "display-4 mb-3",
                                children: "Recent Projects"
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                className: "lead fs-lg",
                                children: [
                                    "We love to turn ideas into ",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "underline",
                                        children: "beautiful things"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "projects-tiles",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "project grid grid-view",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row gx-md-8 gx-xl-12 gy-10 gy-md-12 isotope",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "col-md-5",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ _jsx(Link, {
                                                    // legacyBehavior2 passHref2 
                                                    href: "#",
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        children: /*#__PURE__*/ _jsx("figure", {
                                                            className: "lift rounded mb-6",
                                                            children: /*#__PURE__*/ _jsx("img", {
                                                                src: "/img/photos/rp1.jpg",
                                                                srcSet: "/img/photos/rp1@2x.jpg 2x",
                                                                alt: "demo"
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "post-category mb-3 text-purple",
                                                    children: "Stationary"
                                                }),
                                                /*#__PURE__*/ _jsx("h3", {
                                                    className: "post-title",
                                                    children: "Ipsum Ultricies Cursus"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "item mt-12 mt-md-12",
                                            children: [
                                                /*#__PURE__*/ _jsx(Link, {
                                                    // legacyBehavior2 passHref2 
                                                    href: "#",
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        children: /*#__PURE__*/ _jsx("figure", {
                                                            className: "lift rounded mb-6",
                                                            children: /*#__PURE__*/ _jsx("img", {
                                                                src: "/img/photos/rp3.jpg",
                                                                srcSet: "/img/photos/rp3@2x.jpg 2x",
                                                                alt: "demo"
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "post-category mb-3 text-red",
                                                    children: "Notebook"
                                                }),
                                                /*#__PURE__*/ _jsx("h3", {
                                                    className: "post-title",
                                                    children: "Magna Tristique Inceptos"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "item col-md-7 mt-md-17",
                                    children: [
                                        /*#__PURE__*/ _jsx(Link, {
                                            // legacyBehavior2 passHref2 
                                            href: "#",
                                            children: /*#__PURE__*/ _jsx("a", {
                                                children: /*#__PURE__*/ _jsx("figure", {
                                                    className: "lift rounded mb-6",
                                                    children: /*#__PURE__*/ _jsx("img", {
                                                        src: "/img/photos/rp2.jpg",
                                                        srcSet: "/img/photos/rp2@2x.jpg 2x",
                                                        alt: ""
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "post-category mb-3 text-orange",
                                            children: "Invitation"
                                        }),
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: "post-title",
                                            children: "Mollis Ipsum Mattis"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var portfolio_Portfolio7 = ((/* unused pure expression or super */ null && (Portfolio7)));

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./src/components/blocks/portfolio/Portfolio8.tsx



// -------- data -------- //

var Portfolio8 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-14 py-md-17",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row mb-8 text-center",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-9 col-xl-8 col-xxl-7 mx-auto",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-16 text-uppercase text-primary mb-3",
                                children: "BLOG"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-4",
                                children: "SEOptimist News"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: "Ideas on the latest developments in tech and discussion about trusted methodologies."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "grid grid-view projects-masonry",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "row gx-md-8 gy-10 gy-md-13 isotope",
                        children: portfolioList5.map(function(param) {
                            var id = param.id, image = param.image, title = param.title, category = param.category, color = param.color;
                            return /*#__PURE__*/ _jsxs("div", {
                                className: "project item col-md-6 col-xl-4 product",
                                children: [
                                    /*#__PURE__*/ _jsx("figure", {
                                        className: "lift rounded mb-6",
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            // legacyBehavior2 passHref2 
                                            href: "#",
                                            children: /*#__PURE__*/ _jsx("a", {
                                                children: /*#__PURE__*/ _jsx(Image, {
                                                    width: 1300,
                                                    height: 1132,
                                                    src: image,
                                                    alt: title,
                                                    layout: "responsive"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "project-details d-flex justify-content-center flex-column",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "post-header",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "post-category mb-2 text-".concat(color),
                                                    children: category
                                                }),
                                                /*#__PURE__*/ _jsx("h2", {
                                                    className: "post-title h3",
                                                    children: title
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, id);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var portfolio_Portfolio8 = ((/* unused pure expression or super */ null && (Portfolio8)));

;// CONCATENATED MODULE: ./src/components/blocks/portfolio/Portfolio9.tsx



var Portfolio9 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light wrapper-border",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-14 pt-md-18 pb-md-16",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "row align-items-center mb-10",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "col-md-8 col-lg-9 col-xl-8 col-xxl-7 pe-xl-20",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "display-4 mb-3",
                                    children: "Latest Projects"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "lead fs-20 mb-0",
                                    children: "Check out some of my latest projects with creative ideas."
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-4 col-lg-3 ms-md-auto text-md-end mt-5 mt-md-0",
                            children: /*#__PURE__*/ _jsx(NextLink, {
                                title: "See All Projects",
                                alt: "See All Projects",
                                href: "#",
                                className: "btn btn-outline-primary rounded-pill mb-0"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "card bg-soft-violet mb-10",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "card-body p-12 pb-0",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "col-lg-4 pb-12 align-self-center",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "post-category mb-3 text-violet",
                                            children: "Web Design"
                                        }),
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: "h1 post-title mb-3",
                                            children: "Snowlake Theme"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Maecenas faucibus mollis interdum sed posuere consectetur est at lobortis. Scelerisque id ligula porta felis euismod semper. Fusce dapibus tellus cursus."
                                        }),
                                        /*#__PURE__*/ _jsx(NextLink, {
                                            title: "See Project",
                                            alt: "See Project",
                                            href: "#",
                                            className: "more hover link-violet"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-lg-7 offset-lg-1 align-self-end",
                                    children: /*#__PURE__*/ _jsx("figure", {
                                        children: /*#__PURE__*/ _jsx(Image, {
                                            layout: "responsive",
                                            className: "img-fluid",
                                            src: "/img/photos/f1.png",
                                            width: 650,
                                            height: 370,
                                            alt: ""
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "card bg-soft-blue mb-10",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "card-body p-12",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row gy-10 align-items-center",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "col-lg-4 order-lg-2 offset-lg-1",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "post-category mb-3 text-blue",
                                            children: "Mobile Design"
                                        }),
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: "h1 post-title mb-3",
                                            children: "Budget App"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Maecenas faucibus mollis interdum sed posuere consectetur est at lobortis. Scelerisque id ligula porta felis euismod semper. Fusce dapibus tellus cursus."
                                        }),
                                        /*#__PURE__*/ _jsx(NextLink, {
                                            title: "See Project",
                                            alt: "See Project",
                                            href: "#",
                                            className: "more hover link-blue"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-lg-7",
                                    children: /*#__PURE__*/ _jsx("figure", {
                                        children: /*#__PURE__*/ _jsx(Image, {
                                            layout: "responsive",
                                            className: "img-fluid",
                                            src: "/img/photos/f2.png",
                                            width: 600,
                                            height: 367,
                                            alt: ""
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-md-8 gx-xl-10",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-6",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "card bg-soft-leaf mb-10",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body p-12 pb-0",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "post-category mb-3 text-leaf",
                                                children: "Web Design"
                                            }),
                                            /*#__PURE__*/ _jsx("h3", {
                                                className: "h1 post-title mb-3",
                                                children: "Missio Theme"
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                children: "Maecenas faucibus mollis interdum sed posuere porta consectetur cursus porta lobortis. Scelerisque id ligula felis."
                                            }),
                                            /*#__PURE__*/ _jsx(NextLink, {
                                                title: "See Project",
                                                alt: "See Project",
                                                href: "#",
                                                className: "more hover link-leaf mb-8"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Image, {
                                        layout: "responsive",
                                        className: "img-fluid",
                                        src: "/img/photos/f3.png",
                                        width: 620,
                                        height: 370,
                                        alt: ""
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-6",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "card bg-soft-pink",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body p-12 pb-0",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "post-category mb-3 text-pink",
                                                children: "Mobile Design"
                                            }),
                                            /*#__PURE__*/ _jsx("h3", {
                                                className: "h1 post-title mb-3",
                                                children: "Storage App"
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                children: "Maecenas faucibus mollis interdum sed posuere consectetur est at lobortis. Scelerisque id ligula porta felis euismod semper."
                                            }),
                                            /*#__PURE__*/ _jsx(NextLink, {
                                                title: "See Project",
                                                alt: "See Project",
                                                href: "#",
                                                className: "more hover link-pink mb-8"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Image, {
                                        layout: "responsive",
                                        className: "img-fluid",
                                        src: "/img/photos/f4.png",
                                        width: 620,
                                        height: 370,
                                        alt: ""
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var portfolio_Portfolio9 = ((/* unused pure expression or super */ null && (Portfolio9)));

// EXTERNAL MODULE: ./src/utils/carouselBreakpoints.ts
var utils_carouselBreakpoints = __webpack_require__(32783);
;// CONCATENATED MODULE: ./src/components/reuseable/project-cards/ProjectCard1.tsx



// ==============================================================================
var ProjectCard1 = function(props) {
    var link = props.link, title = props.title, category = props.category, description = props.description, images = props.images;
    return /*#__PURE__*/ _jsx("div", {
        className: "project grid grid-view",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row g-6 isotope",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "item col-md-6",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "project-details d-flex justify-content-center flex-column",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "post-header",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "post-category text-red mb-3",
                                        children: category
                                    }),
                                    /*#__PURE__*/ _jsx("h2", {
                                        className: "post-title mb-3",
                                        children: title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "post-content",
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        children: description
                                    }),
                                    /*#__PURE__*/ _jsx(NextLink, {
                                        title: "See Project",
                                        href: link,
                                        className: "more hover link-red"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                images.map(function(param, i) {
                    var url = param.url, height = param.height, width = param.width, tooltip = param.tooltip, full = param.full;
                    return /*#__PURE__*/ _jsx("div", {
                        className: "item col-md-6",
                        children: /*#__PURE__*/ _jsx("figure", {
                            className: "itooltip itooltip-light hover-scale rounded",
                            title: tooltip,
                            children: /*#__PURE__*/ _jsx("a", {
                                href: full,
                                "data-glightbox": "title: ".concat(tooltip),
                                "data-gallery": "project-2",
                                children: /*#__PURE__*/ _jsx(Image, {
                                    alt: title,
                                    src: url,
                                    layout: "responsive",
                                    width: width,
                                    height: height
                                })
                            })
                        })
                    }, url + i);
                })
            ]
        })
    });
};
/* harmony default export */ var project_cards_ProjectCard1 = ((/* unused pure expression or super */ null && (ProjectCard1)));

;// CONCATENATED MODULE: ./src/components/reuseable/project-cards/ProjectCard2.tsx



// ==============================================================================
var ProjectCard2 = function(props) {
    var link = props.link, title = props.title, category = props.category, description = props.description, image = props.image, imageClassName = props.imageClassName, cardStyle = props.cardStyle, detailsStyle = props.detailsStyle, color = props.color;
    var catColor = color ? "text-".concat(color) : "text-purple";
    var linkColor = color ? "link-".concat(color) : "link-purple";
    return /*#__PURE__*/ _jsx("div", {
        className: "project item",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row",
            children: [
                /*#__PURE__*/ _jsx(FigureImage, {
                    width: image.width,
                    height: image.height,
                    src: image.url,
                    className: imageClassName
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "project-details d-flex justify-content-center flex-column",
                    style: detailsStyle,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "card shadow rellax",
                        "data-rellax-xs-speed": "0",
                        "data-rellax-mobile-speed": "0",
                        style: cardStyle,
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "card-body",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "post-header",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "post-category text-line ".concat(catColor, " mb-3"),
                                            children: category
                                        }),
                                        /*#__PURE__*/ _jsx("h2", {
                                            className: "post-title mb-3",
                                            children: title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "post-content",
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            children: description
                                        }),
                                        /*#__PURE__*/ _jsx(NextLink, {
                                            title: "See Project",
                                            href: link,
                                            className: "more hover ".concat(linkColor)
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var project_cards_ProjectCard2 = ((/* unused pure expression or super */ null && (ProjectCard2)));

;// CONCATENATED MODULE: ./src/components/reuseable/project-cards/ProjectCard3.tsx



// ==============================================================================
var ProjectCard3_ProjectCard3 = function(param) {
    var link = param.link, title = param.title, image = param.image, category = param.category, fullImage = param.fullImage;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("figure", {
                className: "rounded mb-6",
                children: [
                    /*#__PURE__*/ _jsx(Image, {
                        width: 410,
                        height: 440,
                        src: image,
                        alt: title,
                        layout: "responsive"
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        className: "item-link",
                        href: fullImage,
                        "data-glightbox": true,
                        "data-gallery": "projects-group",
                        children: /*#__PURE__*/ _jsx("i", {
                            className: "uil uil-focus-add"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "project-details d-flex justify-content-center flex-column",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "post-header",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "post-title h3",
                            children: /*#__PURE__*/ _jsx(NextLink, {
                                href: link,
                                title: title,
                                className: "link-dark"
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "post-category text-ash",
                            children: category
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var project_cards_ProjectCard3 = ((/* unused pure expression or super */ null && (ProjectCard3_ProjectCard3)));

;// CONCATENATED MODULE: ./src/components/reuseable/project-cards/index.ts





;// CONCATENATED MODULE: ./src/components/blocks/portfolio/Portfolio10.tsx






// -------- data -------- //

var Portfolio10 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "row mt-17",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-lg-10 col-xl-9 col-xxl-8 mx-auto text-center",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "fs-16 text-uppercase text-muted mb-3",
                            children: "Latest Projects"
                        }),
                        /*#__PURE__*/ _jsxs("h3", {
                            className: "display-3 mb-10",
                            children: [
                                "Check out some of our awesome projects with ",
                                /*#__PURE__*/ _jsx("span", {
                                    className: "underline-3 style-2 yellow",
                                    children: "creative"
                                }),
                                " ",
                                "ideas and great design."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Carousel, {
                navigation: false,
                grabCursor: true,
                breakpoints: carouselBreakpoints,
                children: portfolioList6.map(function(item) {
                    return /*#__PURE__*/ _jsx(ProjectCard3, _object_spread({}, item), item.id);
                })
            })
        ]
    });
};
/* harmony default export */ var portfolio_Portfolio10 = ((/* unused pure expression or super */ null && (Portfolio10)));

;// CONCATENATED MODULE: ./src/components/blocks/portfolio/Portfolio11.tsx




// -------- data -------- //

var Portfolio11 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-15 py-md-17",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-11 col-xl-10 mx-auto mb-10",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-16 text-uppercase text-muted text-center mb-3",
                                children: "Our Projects"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-3 text-center px-lg-5 px-xl-10 px-xxl-16 mb-0",
                                children: "Check out some of our awesome projects with creative ideas and great design."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "grid grid-view projects-masonry",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "row gx-md-8 gy-10 gy-md-13 isotope",
                        children: portfolioList6.map(function(item) {
                            return /*#__PURE__*/ _jsx("div", {
                                className: "project item col-md-6 col-xl-4",
                                children: /*#__PURE__*/ _jsx(ProjectCard3, _object_spread({}, item))
                            }, item.id);
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center mt-10",
                    children: /*#__PURE__*/ _jsx(NextLink, {
                        title: "Start a Project",
                        href: "#",
                        className: "btn btn-lg btn-primary rounded-pill"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var portfolio_Portfolio11 = ((/* unused pure expression or super */ null && (Portfolio11)));

;// CONCATENATED MODULE: ./src/components/blocks/portfolio/Portfolio12.tsx






// -------- data -------- //

var Portfolio12 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "row",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-lg-10 col-xl-8 mx-auto text-center",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "fs-16 text-uppercase text-muted mb-3",
                            children: "Latest Projects"
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "display-4 mb-10 px-xxl-10",
                            children: "Check out some of our awesome projects with creative ideas and great design."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Carousel, {
                navigation: false,
                grabCursor: true,
                breakpoints: carouselBreakpoints,
                children: portfolioList6.map(function(item) {
                    return /*#__PURE__*/ _jsx(ProjectCard3, _object_spread({}, item), item.id);
                })
            })
        ]
    });
};
/* harmony default export */ var portfolio_Portfolio12 = ((/* unused pure expression or super */ null && (Portfolio12)));

;// CONCATENATED MODULE: ./src/components/blocks/portfolio/InternationalSEO.tsx


// -------- data -------- //


var InternationalSEO = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container-fluid",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(reuseable_Carousel/* default */.Z, {
            grabCursor: true,
            className: "blog grid-view mb-1 mb-md-1",
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                768: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 2
                }
            },
            children: keywords.InternationalSEOArrays.map(function(param) {
                var item = param.item, title = param.title;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        cursor: "pointer"
                    },
                    className: "card overflow-hidden shadow-none position-relative",
                    title: title,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        //legacyBehavior2 passHref2
                        href: keywords.InternationalSEOArrays[item].keywords[0].url + "/" + keywords.InternationalSEOArrays[item].keywords[0].title.toLowerCase().replace(/ /g, "-"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                    className: "w-100 overflow-hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: keywords.InternationalSEOArrays[item].keywords[1].title,
                                        src: "/img/clients/" + keywords.InternationalSEOArrays[item].keywords[1].title.toLowerCase().replace(/ /g, "-") + ".jpg",
                                        // srcSet={`${image}@2x.jpg 2x`}
                                        className: "d-block w-100"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "card-body",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                                        className: "border-0 mb-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "blockquote-details",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "info",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        className: "mb-0 ".concat(keywords.InternationalSEOArrays[item].displayTextColor, " font-weight-bold"),
                                                        children: title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mb-0 ".concat(keywords.InternationalSEOArrays[item].displayTextColor, " desktop"),
                                                        children: keywords.InternationalSEOArrays[item].category
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "d-lg-none",
                                    children: title
                                })
                            ]
                        })
                    })
                }, item);
            })
        })
    });
};
/* harmony default export */ var portfolio_InternationalSEO = (InternationalSEO);

;// CONCATENATED MODULE: ./src/components/blocks/portfolio/index.ts
















/***/ })

}]);